var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQOsCixfz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#B1A5DA",
    d: "M18 9.165L18 19.162 0 19.162 0 1.162 10.11 1.162",
    transform: "translate(-628 -1276) translate(194 1031) translate(0 166) translate(436 80.838)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#644EB2",
    d: "M6.634 12.35L18.984 0",
    transform: "translate(-628 -1276) translate(194 1031) translate(0 166) translate(436 80.838)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQOsCixfz);
export default __webpack_public_path__ + "static/media/qOSCixfz.0d1ca0ecdc4bcc7114668470a42f2f81.svg";
export { ForwardRef as ReactComponent };